export default __webpack_public_path__ + "static/media/work.a5a85376.svg";